import {FormattedMessage, useIntl} from "react-intl";
import React, {Fragment} from "react";
import {IconButton} from "../../../shared";
import auth from "../../../../utils/authentication";
import InviteMenu from "../inviteMenu/inviteMenu";
import {
    ACCEPT_USERS,
    GROUP_PRIVATE,
    INVITE_USERS,
    KICK_USERS,
    MANAGE_ROLES,
    MANAGE_TAGS
} from "../../../../utils/consts";
import functions from "../../../../utils/functionsFirebase";
import groupIndex from "../../index";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import UserInfo from "../../../shared/userInfo/user-info";
import RolesMenu from "../rolesMenu/rolesMenu";
import UsersMenu from "../usersMenu/usersMenu";
import {checkUserGroupRole} from "../../../../utils/utils";
import TagsMenu from "../tagsMenu/tagsMenu";

function GroupMenu({
                       group, setGroup, askedUsers, setAskedUsers, closeModal, userRoles, roles, setRoles, loadingLeave,
                       setLoadingLeave, tags, setTags
                   }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const intl = useIntl();

    const userGroups = useSelector(groupIndex.selectors.userGroups);

    async function acceptJoinUser(user, index, accept) {
        setAskedUsers(previous => {
            const aux = [...previous]
            aux[index].loading = true;
            return aux;
        });
        const acceptJoinGroup = functions.httpsCallable('acceptJoinUser');
        const res = await acceptJoinGroup({groupId: group.id, accept, userUid: user.uid});
        if (res.data.success) {
            setAskedUsers(previous => {
                const aux = [...previous]
                aux.splice(index, 1);
                return aux;
            });
            if (accept) {
                setGroup(previous => {
                    previous.joinedUsers = group.joinedUsers + 1;
                    dispatch(groupIndex.actions.updateLoadedGroup(previous));
                    return previous;
                })
            }
        }
    }

    const hasRightManageTags = () => {
        return checkUserGroupRole(userRoles, roles, MANAGE_TAGS, group);
    }

    const hasRightManageRoles = () => {
        return checkUserGroupRole(userRoles, roles, MANAGE_ROLES, group);
    }

    const hasRightInviteUsers = () => {
        return checkUserGroupRole(userRoles, roles, INVITE_USERS, group);
    }

    const hasRightAcceptUsers = () => {
        return group.privacy === GROUP_PRIVATE && checkUserGroupRole(userRoles, roles, ACCEPT_USERS, group);
    }

    const hasRightKickUsers = () => {
        return checkUserGroupRole(userRoles, roles, KICK_USERS, group);
    }

    const hasRightDeleteGroup = () => {
        //Only creator should have this right.
        return group.uidCreator === auth.currentUser?.uid;
    }

    async function leaveGroup() {
        setLoadingLeave(true);
        const leaveGroup = functions.httpsCallable('leaveGroup');
        try {
            await leaveGroup({groupId: group.id});
            closeModal();
            setLoadingLeave(false);
            dispatch(groupIndex.actions.deletedGroup(group));
            navigate('/groups');
            toast.success(intl.formatMessage({id: 'group-details.group-menu.leave-group.success'}));
        } catch (e) {
            if (e.toString().includes('permission-denied')) {
                //This error happens when I want to leave a group, but I am the last user in the group.
                toast.error(intl.formatMessage({id: 'group-details.group-menu.leave-group.error'}))
                setLoadingLeave(false);
            }
        }
    }

    async function deleteGroup() {
        setLoadingLeave(true);
        const deleteGroup = functions.httpsCallable('deleteGroup');
        try {
            await deleteGroup({groupId: group.id});
            closeModal();
            dispatch(groupIndex.actions.deletedGroup(group));
            navigate('/groups');
            toast.success(intl.formatMessage({id: 'group-details.group-menu.delete-group.success'}));
        } catch (e) {
            // No error should happen
            toast.error(intl.formatMessage({id: 'group-details.group-menu.delete-group.error'}))
            setLoadingLeave(false);
        }
    }

    async function resetUsersRoles() {
        setLoadingLeave(true);
        const resetRoles = functions.httpsCallable('resetUsersRoles');
        await resetRoles({groupId: group.id});
        setLoadingLeave(false);
    }

    return (
        <Fragment>
            <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"><FormattedMessage
                    id={"group-details.group-menu"}/></h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <div className="accordion" id="accordionOptions">
                    {hasRightAcceptUsers() &&
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed" type="button"
                                        data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                        aria-expanded="false" aria-controls="collapseOne">
                                    <FormattedMessage id="group-details.group-menu.join-petitions"/>
                                    <span
                                        className="badge text-bg-danger ms-2">{askedUsers?.length ?? 0}</span>
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse"
                                 data-bs-parent="#accordionOptions">
                                <div className="accordion-body">
                                    <ul className="list-group">
                                        {askedUsers?.map((user, i) => {
                                            return (<li className="list-group-item"
                                                        key={user.uid}>
                                                <div
                                                    className="d-flex flex-row justify-content-between align-items-center">
                                                    <UserInfo initialUser={user} uid={user.uid}/>
                                                    <div className="d-flex flex-row">
                                                        {!user.loading && <Fragment>
                                                            <IconButton
                                                                onClick={() => acceptJoinUser(user, i, true)}
                                                                icon="fa-solid fa-check fa-lg text-success"
                                                                className="m-1 p-1"/>
                                                            <IconButton
                                                                onClick={() => acceptJoinUser(user, i, false)}
                                                                icon="fa-solid fa-xmark fa-lg text-danger"
                                                                className="m-1 p-1"/>
                                                        </Fragment>}
                                                        {user.loading && <Fragment>
                                                            <i className="fa-solid fa-spinner fa-spin fa-lg"></i>
                                                        </Fragment>}
                                                    </div>
                                                </div>
                                            </li>)
                                        })}
                                        {!askedUsers?.length &&
                                            <div style={{fontSize: "small"}} className="ms-2">
                                                <FormattedMessage
                                                    id="group-details.group-menu.no-join-petitions"/>
                                            </div>
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>}
                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#usersListMenu"
                                    aria-expanded="false" aria-controls="usersListMenu">
                                <FormattedMessage id="group-details.group-menu.users"/>
                            </button>
                        </h2>
                        <div id="usersListMenu" className="accordion-collapse collapse"
                             data-bs-parent="#accordionOptions">
                            <div className="accordion-body">
                                <UsersMenu group={group} hasRightManageRoles={hasRightManageRoles()} roles={roles}
                                           hasRightKickUsers={hasRightKickUsers()}/>
                            </div>
                        </div>
                    </div>
                    {hasRightInviteUsers() &&
                        <div className="accordion-item">
                            <h2 className="accordion-header">
                                <button className="accordion-button collapsed" type="button"
                                        data-bs-toggle="collapse" data-bs-target="#inviteUsersMenu"
                                        aria-expanded="false" aria-controls="inviteUsersMenu">
                                    <FormattedMessage id="group-details.group-menu.invite-users"/>
                                </button>
                            </h2>
                            <div id="inviteUsersMenu" className="accordion-collapse collapse"
                                 data-bs-parent="#accordionOptions">
                                <div className="accordion-body">
                                    <InviteMenu group={group}/>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="accordion-item" hidden={!hasRightManageRoles()}>
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#rolesOptionsMenu"
                                    aria-expanded="false" aria-controls="rolesOptionsMenu">
                                <FormattedMessage id="group-details.group-menu.roles"/>
                            </button>
                        </h2>
                        <div id="rolesOptionsMenu" className="accordion-collapse collapse"
                             data-bs-parent="#accordionOptions">
                            <div className="accordion-body">
                                <RolesMenu group={group} hasRightManageRoles={hasRightManageRoles()} roles={roles}
                                           setRoles={setRoles}/>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#tagsOptionsMenu"
                                    aria-expanded="false" aria-controls="tagsOptionsMenu">
                                <FormattedMessage id="group-details.group-menu.tags"/>
                            </button>
                        </h2>
                        <div id="tagsOptionsMenu" className="accordion-collapse collapse"
                             data-bs-parent="#accordionOptions">
                            <div className="accordion-body">
                                <TagsMenu group={group} hasRightManageTags={hasRightManageTags()} tags={tags}
                                          setTags={setTags}/>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button className="accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse" data-bs-target="#groupActionsMenu"
                                    aria-expanded="false" aria-controls="groupActionsMenu">
                                <FormattedMessage id="group-details.group-menu.danger-options"/>
                            </button>
                        </h2>
                        <div id="groupActionsMenu" className="accordion-collapse collapse"
                             data-bs-parent="#accordionOptions">
                            <div className="accordion-body">
                                {hasRightDeleteGroup() &&
                                    <button disabled={loadingLeave} type="danger"
                                            className="btn btn-outline-danger me-3" onClick={deleteGroup}>
                                        <FormattedMessage
                                            id="group-details.group-menu.delete-group"/>
                                    </button>}

                                <button disabled={loadingLeave} type="danger"
                                        className="btn btn-danger" onClick={leaveGroup}><FormattedMessage
                                    id="group-details.group-menu.leave-group"/></button>

                                {/*{hasRightDeleteGroup() &&
                                    <button disabled={loadingLeave} className="btn btn-secondary ms-3"
                                            onClick={resetUsersRoles}
                                            title={intl.formatMessage({id: "group-details.group-menu.reload-roles"})}>
                                        <i className="fa-solid fa-rotate"></i>
                                    </button>}*/}

                                {(loadingLeave) &&
                                    <i className="fa-solid fa-spinner fa-spin ms-4 fa-xl"></i>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default GroupMenu;
